export class EngubatorPlanningZone {
    id: number;
    code: string;
    name: string;
    regions: string[] = [];
}
